import React, { useEffect, useState } from "react";
import nodataImage from "../../assets/images/svg/nodataImage.svg";
import Table from "../../components/Table2";
import TableSkeleton from "../../components/TableSkeleton/TableSkeleton";
import UserStore from "../../store/UserStore";
import { observer } from "mobx-react";
import { sortData } from "../../utils/functions";
import {
  filterKeyNameArray,
  filterKeyValue,
  //offshoreSummaryId,
} from "../../utils/constants";
//import PdfTable from "../../components/PdfTable/PdfTable";
import Modal from "../../components/Modal";
import OffshoreTransactions from "./OffshoreTransactions";

const EmptyTable = ({ isLoading = false }) => {
  return (
    <div
      style={{
        backgroundColor: "#F6F7FA",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: "32px",
        borderRadius: "15px",
        height: "300px",
        width: "100%",
        marginTop: "20px",
      }}
    >
      {!isLoading && (
        <>
          <img
            style={{
              width: "fit-content",
            }}
            src={nodataImage}
            alt="noData"
          />
          <p
            style={{
              fontFamily: "Encode Sans",
              color: "#7E8899",
              fontWeight: "600",
              fontSize: "18px",
            }}
          >
            No data found
          </p>
        </>
      )}
    </div>
  );
};

const SubAssetTable = observer(
  ({
    search,
    fileColumns,
    pdfData,
    openModal,
    setOpenModal,
    transactionColumns,
    transactionsData,
    headerName,
    isTransactionLoading,
    ...rest
  }) => {
    const [vertualRows, setVertualRows] = useState([]);
    const [selectedColumn, setSelectedColumn] = useState("current_value");
    const [isAscending, setIsAscending] = useState(false);

    const isHydrated = UserStore.isHydrated;
    const updatedInstruments = UserStore.updatedOffshoreInstruments;
    const selectedInstrument = UserStore.selectedOffshoreInstrument;

    useEffect(() => {
      let mainData = selectedInstrument?.modifiedVehicleData;
      if (isHydrated) {
        let rowData = [];
        rowData = mainData?.filter((data) => {
          if (!search) return true;
          else
            return data?.instrument_name
              ?.toLowerCase()
              ?.includes(search?.toLowerCase());
        });

        if (rowData?.length) {
          let sortedColumnData = [];

          if (selectedColumn === "subtext") {
            sortedColumnData = [...rowData]?.sort(
              (a, b) =>
                Number(a?.unrealised_gain?.[selectedColumn]) -
                Number(b?.unrealised_gain?.[selectedColumn]),
            );
            UserStore.setUserStoreData(
              "updatedOffshoreInstruments",
              isAscending ? sortedColumnData : sortedColumnData.reverse(),
            );
          } else if (selectedColumn === "actualWholeObject") {
            sortedColumnData = [...rowData]?.sort((a, b) => {
              let aa = a?.[selectedColumn]?.inceptiondate?.split("-")?.join();
              let bb = b?.[selectedColumn]?.inceptiondate?.split("-")?.join();
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            });
            UserStore.setUserStoreData(
              "updatedOffshoreInstruments",
              isAscending ? sortedColumnData : sortedColumnData.reverse(),
            );
          } else if (selectedColumn === "instrument") {
            sortedColumnData = [...rowData]?.sort(
              (a, b) =>
                Number(a?.actualWholeObject.instrument.quantity) -
                Number(b?.actualWholeObject.instrument.quantity),
            );
            UserStore.setUserStoreData(
              "updatedOffshoreInstruments",
              isAscending ? sortedColumnData : sortedColumnData.reverse(),
            );
          } else if (filterKeyNameArray.includes(selectedColumn)) {
            UserStore.setUserStoreData(
              "updatedOffshoreInstruments",
              sortData({
                sortingOrder: isAscending,
                rowData,
                keyName: selectedColumn,
                type:
                  selectedColumn === "instrument_name" ? "string" : "number",
                keyName2: false,
              }),
            );
          } else {
            UserStore.setUserStoreData(
              "updatedOffshoreInstruments",
              sortData({
                sortingOrder: isAscending,
                rowData,
                keyName: false,
                type:
                  selectedColumn === "instrument_name" ? "string" : "number",
                keyName2: filterKeyValue[selectedColumn],
              }),
            );
          }
        } else {
          UserStore.setUserStoreData("updatedOffshoreInstruments", []);
        }
      }

      // eslint-disable-next-line
    }, [
      selectedColumn,
      isAscending,
      search,
      selectedInstrument?.modifiedVehicleData,
    ]);

    useEffect(() => {
      window.scrollTo(0, 0);
      document.addEventListener("scroll", () => {
        if (document.documentElement.scrollTop === 0) {
          setVertualRows(UserStore.updatedOffshoreInstruments?.slice(0, 100));
        }
        if (
          document.documentElement.scrollHeight -
            document.documentElement.scrollTop +
            document.documentElement.clientHeight <
            2000 &&
          UserStore.updatedOffshoreInstruments?.length
        ) {
          if (vertualRows) {
            setVertualRows((prev) => {
              if (prev) {
                return [
                  ...prev,
                  ...UserStore.updatedOffshoreInstruments?.slice(
                    prev?.length,
                    prev?.length + 100,
                  ),
                ];
              }
            });
          }
        }
      });

      return () => {
        UserStore.setFilterStatus(false);
      };
      // eslint-disable-next-line
    }, []);

    useEffect(() => {
      if (updatedInstruments.length) {
        setVertualRows(updatedInstruments?.slice(0, 100));
      } else {
        setVertualRows([]);
      }
    }, [updatedInstruments]);

    return (
      <>
        {UserStore.isInstrumentsDataLoading ? (
          <div style={{ width: "100%", marginTop: "26px" }}>
            {" "}
            <TableSkeleton />
          </div>
        ) : (
          <>
            <div
              style={{
                backgroundColor: "#FFF",
                height: 12,
                width: "100%",
                position: "sticky",
                top: 0,
              }}
            />
            {!!selectedInstrument?.modifiedVehicleData && (
              <Table
                classUnrealised={"lowerRightPadding"}
                tableClass={`equity_summary_table option4`}
                EmptyStateBody={<EmptyTable isLoading={false} />}
                handleSort={(key) => {
                  setSelectedColumn(key);
                  setIsAscending(!isAscending);
                }}
                sortKey={selectedColumn}
                isAscending={isAscending}
                data={vertualRows}
                isTableLoader={true}
                {...rest}
              />
            )}
          </>
        )}

        <Modal
          mdlStyle={{ backgroundColor: "rgba(0, 0, 0, 0.75)" }}
          modalStyle={{
            height: "510px",
          }}
          onClose={() => setOpenModal(false)}
          open={openModal}
          width={
            document.documentElement.clientWidth > 1200 ? "1200px" : "990px"
          }
          minWidth={"890px"}
          modalContainerClass={`snapshot_modal_container quickviewModal `}
        >
          {openModal && (
            <OffshoreTransactions
              isLoading={isTransactionLoading}
              columns={transactionColumns}
              transactions={transactionsData}
              instrument={UserStore.offshoreInstrumentTransactions}
            />
          )}
        </Modal>

        <div>
          {/* <PdfTable
            headerName={headerName}
            columns={fileColumns}
            data={pdfData}
            id={offshoreSummaryId}
          /> */}
        </div>
      </>
    );
  },
);

export default SubAssetTable;
